import BenchmarkingTab from './BenchmarkingTab'

export default BenchmarkingTab
